// extracted by mini-css-extract-plugin
module.exports = {"container":"_017a807","closeContainer":"_17aa938","gamesContainer":"_5b77abf","header":"_6789b1c","gameList":"_8a7082e"};